import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const CellStyle = {
  border: '1px solid lightgrey',
  padding: 8,
  overflow: 'hidden',
  minWidth: 0
};

const HeaderStyle = {
  ...CellStyle,
  fontWeight: 600
};

// prettier-ignore
const tryParseJSON = (message) => {
  try {
    return JSON.parse(message);
  } catch {//NOSONAR
    return null;
  }
};

// Table to display a list of voice media file URLs in the HBS S3 bucket. Includes a column indicating whether the media is complete.
export default function VoiceMediaTable({ events }: { events: { event: 'VOICECB' | 'VIDEOCB'; message: string }[] }) {
  const { t } = useTranslation('common');
  const hookEvents = events
    .filter((e) => e.event === 'VOICECB' || e.event === 'VIDEOCB')
    .map((e) => ({ ...e, messageJSON: tryParseJSON(e.message) }));

  const voiceMedia = new Set<string>(hookEvents.map((e) => e.messageJSON?.RecordingUrl).filter((url) => url));
  const completedVoiceMedia = new Set<string>(
    hookEvents
      .map((e) => e.messageJSON?.RecordingStatus === 'completed' && e.messageJSON?.RecordingUrl)
      .filter((url) => url)
  );

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, max-content) minmax(0, 10fr)',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        border: '1px solid lightgrey'
      }}
    >
      {/* Header */}
      <div style={{ display: 'contents' }}>
        <div style={HeaderStyle}>{t('completed')}</div>
        <div style={HeaderStyle}>{t('media')}</div>
      </div>

      <div style={{ display: 'contents' }}>
        {[...voiceMedia].map((url) => (
          <Fragment key={url}>
            <div style={CellStyle}>{completedVoiceMedia.has(url) ? '✅' : '❌'}</div>
            <div style={CellStyle}>{url}</div>
          </Fragment>
        ))}
      </div>
    </div>
  );
}
